import { render, staticRenderFns } from "./SwiperList.vue?vue&type=template&id=079739be&scoped=true"
import script from "./SwiperList.vue?vue&type=script&lang=ts"
export * from "./SwiperList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079739be",
  null
  
)

export default component.exports